<template>
  <div class="card p-4 shadow-sm">
    <button class="btn btn-outline-secondary btn-sm mb-3" @click="$router.push('/inicio')">
      <i class="bi bi-arrow-left me-1"></i> Regresar
    </button>

    <h4 class="mb-3">Ingresos Restaurante</h4>

    <!-- Pestañas -->
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: vista === 'resumen' }" @click="vista = 'resumen'">Resumen</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: vista === 'detallado' }" @click="vista = 'detallado'">Detallado</button>
      </li>
    </ul>

    <!-- ======================== RESUMEN ======================== -->
    <div v-if="vista === 'resumen'">
      <div class="mb-3">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-sm" :class="tipoBusqueda === 'fecha' ? 'btn-primary' : 'btn-outline-secondary'" @click="tipoBusqueda = 'fecha'">Fecha Única</button>
          <button type="button" class="btn btn-sm" :class="tipoBusqueda === 'rango' ? 'btn-primary' : 'btn-outline-secondary'" @click="tipoBusqueda = 'rango'">Rango de Fechas</button>
        </div>
      </div>

      <div v-if="tipoBusqueda === 'fecha'" class="row g-2 align-items-end mb-3">
        <div class="col-md-2"><label class="form-label small text-muted">Fecha</label><input type="date" v-model="fecha" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora inicio</label><input type="time" v-model="horaInicio" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora fin</label><input type="time" v-model="horaFin" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Ordenar por</label>
          <select v-model="ordenar" class="form-select form-select-sm">
            <option value="metodo_asc">Método (A-Z)</option>
            <option value="total_desc">Total (mayor)</option>
            <option value="total_asc">Total (menor)</option>
          </select>
        </div>
        <div class="col-md-1"><button class="btn btn-primary btn-sm w-100" @click="obtenerReporte">Buscar</button></div>
        <div class="col-md-1"><button class="btn btn-danger btn-sm w-100" @click="descargarPDF" :disabled="!reporte"><i class="bi bi-file-pdf"></i> PDF</button></div>
        <div class="col-md-1"><button class="btn btn-success btn-sm w-100" @click="descargarExcel" :disabled="!reporte"><i class="bi bi-file-earmark-excel"></i> Excel</button></div>
      </div>

      <div v-if="tipoBusqueda === 'rango'" class="row g-2 align-items-end mb-3">
        <div class="col-md-2"><label class="form-label small text-muted">Fecha Inicio</label><input type="date" v-model="fechaInicio" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora inicio</label><input type="time" v-model="horaInicio" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Fecha Fin</label><input type="date" v-model="fechaFin" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora fin</label><input type="time" v-model="horaFin" class="form-control form-control-sm" /></div>
        <div class="col-md-1"><button class="btn btn-primary btn-sm w-100" @click="obtenerReporte" :disabled="!fechaInicio || !fechaFin">Buscar</button></div>
        <div class="col-md-1"><button class="btn btn-danger btn-sm w-100" @click="descargarPDF" :disabled="!reporte"><i class="bi bi-file-pdf"></i> PDF</button></div>
        <div class="col-md-1"><button class="btn btn-success btn-sm w-100" @click="descargarExcel" :disabled="!reporte"><i class="bi bi-file-earmark-excel"></i> Excel</button></div>
      </div>

      <div v-if="cargandoResumen" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary"></div>
        <span class="ms-2 text-muted">Cargando...</span>
      </div>

      <div v-if="reporte && !cargandoResumen" class="resultado-card">
        <div class="text-muted small mb-2">
          <span v-if="tipoBusqueda === 'fecha'">{{ formatearFecha(reporte.fecha) }}</span>
          <span v-else>{{ formatearFecha(reporte.fecha_inicio) }} al {{ formatearFecha(reporte.fecha_fin) }}</span>
          <span class="ms-2 text-secondary">| {{ horaInicio }} – {{ horaFin }}</span>
        </div>
        <div class="total-monto">Q{{ Number(reporte.total_restaurante).toFixed(2) }}</div>
        <div class="text-muted small">Total generado</div>
        <div v-if="desgloseOrdenado.length" class="mt-4">
          <h6 class="text-muted">Desglose por método de pago</h6>
          <table class="table table-sm table-bordered text-center mx-auto" style="max-width:400px">
            <thead class="table-light"><tr><th>Método</th><th>Total (Q)</th></tr></thead>
            <tbody>
              <tr v-for="item in desgloseOrdenado" :key="item.metodo">
                <td>{{ item.metodo }}</td>
                <td>Q{{ Number(item.total).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ======================== DETALLADO ======================== -->
    <div v-if="vista === 'detallado'">
      <div class="row g-2 align-items-end mb-3">
        <div class="col-md-2"><label class="form-label small text-muted">Fecha Inicio</label><input type="date" v-model="dFechaInicio" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora inicio</label><input type="time" v-model="dHoraInicio" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Fecha Fin</label><input type="date" v-model="dFechaFin" class="form-control form-control-sm" /></div>
        <div class="col-md-2"><label class="form-label small text-muted">Hora fin</label><input type="time" v-model="dHoraFin" class="form-control form-control-sm" /></div>
        <div class="col-md-2">
          <label class="form-label small text-muted">Estado</label>
          <select v-model="dFiltroEstado" class="form-select form-select-sm">
            <option value="todos">Todos</option>
            <option value="0">Activos</option>
            <option value="1">Anulados</option>
          </select>
        </div>
        <div class="col-md-2 d-flex gap-1">
          <button class="btn btn-primary btn-sm flex-fill" @click="buscarDetalle" :disabled="cargandoDetalle || !dFechaInicio || !dFechaFin">
            <span v-if="cargandoDetalle" class="spinner-border spinner-border-sm me-1"></span>
            Buscar
          </button>
        </div>
      </div>

      <div class="d-flex gap-2 mb-3" v-if="reporteDetalle">
        <button class="btn btn-danger btn-sm" @click="exportarDetalle('pdf')"><i class="bi bi-file-pdf me-1"></i>PDF</button>
        <button class="btn btn-success btn-sm" @click="exportarDetalle('excel')"><i class="bi bi-file-earmark-excel me-1"></i>Excel</button>
      </div>

      <!-- Total general -->
      <div v-if="reporteDetalle" class="mb-3 d-flex gap-2 flex-wrap">
        <div class="badge bg-success fs-6">Total General: Q{{ numFmt(reporteDetalle.total_general) }}</div>
        <div class="badge bg-secondary fs-6">Pagos: {{ reporteDetalle.data.length }}</div>
        <div class="badge bg-primary fs-6">Base: Q{{ numFmt(reporteDetalle.totales?.total_base) }}</div>
        <div class="badge bg-info text-dark fs-6">IVA: Q{{ numFmt(reporteDetalle.totales?.total_iva) }}</div>
        <div class="badge bg-warning text-dark fs-6">Comisión Tarjetas: Q{{ numFmt(reporteDetalle.totales?.comision_tarjetas) }}</div>
        <div class="badge bg-dark fs-6">Gastos Generales: Q{{ numFmt(reporteDetalle.totales?.total_gastos_generales) }}</div>
      </div>

      <!-- Tabla detallada -->
      <div v-if="reporteDetalle" class="table-responsive">
        <table class="table table-sm table-bordered align-middle text-center">
          <thead class="table-dark">
            <tr>
              <th>Mesa</th>
              <th>Comanda</th>
              <th>Usuario</th>
              <th>Referencia</th>
              <th>Lo consumido</th>
              <th>Método</th>
              <th>Estado</th>
              <th>Total</th>
              <th>Base</th>
              <th>Gastos</th>
              <th>IVA</th>
              <th>Fecha/Hora</th>
              <th>FEL</th>
              <th>Fac. Cancel.</th>
              <th v-if="esContador">Editar</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="fila in reporteDetalle.data" :key="fila.id">
              <!-- Fila de subtotal por día cuando cambia el día -->
              <tr v-if="fila._subtotal_dia" class="table-success fw-bold">
                <td colspan="7">Subtotal {{ fila._subtotal_dia }}</td>
                <td>Q{{ numFmt(fila._subtotal_monto) }}</td>
                <td :colspan="esContador ? 7 : 6"></td>
              </tr>
              <tr :class="{ 'table-danger': fila.estado_pago === 'Anulado' }">
                <td>{{ fila.mesa || '—' }}</td>
                <td>{{ fila.num_comanda || '—' }}</td>
                <td class="text-start small">{{ fila.usuario_pago || '—' }}</td>
                <td class="small">{{ fila.numero_referencia && fila.numero_referencia !== '—' ? fila.numero_referencia : '' }}{{ fila.numero_factura_manual && fila.numero_factura_manual !== '—' ? ' / ' + fila.numero_factura_manual : '' }}</td>
                <td class="text-start small">
                  <span v-for="(item, i) in (fila.items || [])" :key="i">
                    {{ item.cantidad }}x {{ item.platillo }}<span v-if="i < fila.items.length - 1">, </span>
                  </span>
                  <span v-if="!fila.items || !fila.items.length" class="text-muted">—</span>
                </td>
                <td>{{ fila.metodo_pago }}</td>
                <td>
                  <span class="badge" :class="fila.estado_pago === 'Anulado' ? 'bg-danger' : 'bg-success'">
                    {{ fila.estado_pago }}
                  </span>
                </td>
                <td class="fw-bold">Q{{ numFmt(fila.monto) }}</td>
                <td>Q{{ numFmt(fila.base) }}</td>
                <td>
                  <input
                    v-if="esAdminOContador"
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control form-control-sm text-end"
                    style="width: 90px"
                    :value="fila.gastos_generales"
                    :disabled="guardandoGastos === fila.id || fila.estado_pago === 'Anulado'"
                    @change="guardarGastosRest(fila, $event)"
                  />
                  <span v-else>{{ numFmt(fila.gastos_generales) }}</span>
                </td>
                <td>Q{{ numFmt(fila.iva) }}</td>
                <td class="small">{{ fila.fecha_hora }}</td>
                <td>
                  <button v-if="fila.fel_uuid" class="btn btn-sm btn-link p-0" @click="verFactura(fila.fel_uuid)">
                    {{ fila.fel_serie }}-{{ fila.fel_numero }}
                  </button>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <span :class="fila.factura_cancelada === 'Sí' ? 'text-danger' : 'text-success'">{{ fila.factura_cancelada }}</span>
                </td>
                <td v-if="esContador">
                  <button class="btn btn-outline-warning btn-sm" @click="abrirEditarRest(fila)" :disabled="fila.estado_pago === 'Anulado'">
                    <i class="bi bi-pencil me-1"></i> Editar
                  </button>
                </td>
              </tr>
            </template>
            <tr v-if="!reporteDetalle.data.length">
              <td :colspan="esContador ? 15 : 14" class="text-muted">Sin registros para el período seleccionado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal previsualización FEL -->
    <FelPreviewModal v-if="felUuidPreview" :uuid="felUuidPreview" @cerrar="felUuidPreview = null" />

    <!-- Modal editar pago restaurante (solo Contador) -->
    <div v-if="modalEditarRest" class="modal fade show d-block" style="background:rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Pago Restaurante #{{ pagoEditarRest.id }}</h5>
            <button class="btn-close" @click="modalEditarRest = false"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Monto (Q)</label>
              <input type="number" v-model.number="pagoEditarRest.monto" class="form-control" min="0.01" step="0.01" />
            </div>
            <div class="mb-3">
              <label class="form-label">Nº Referencia</label>
              <input type="text" v-model="pagoEditarRest.numero_referencia" class="form-control" />
            </div>
            <div class="mb-3">
              <label class="form-label">Justificación <span class="text-danger">*</span></label>
              <textarea v-model="pagoEditarRest.justificacion" class="form-control" rows="3"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="modalEditarRest = false">Cancelar</button>
            <button class="btn btn-primary" @click="guardarEdicionRest" :disabled="guardandoRest">
              <span v-if="guardandoRest" class="spinner-border spinner-border-sm me-1"></span>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="toast.show" class="toast-container position-fixed top-0 end-0 p-3" style="z-index:1055">
      <div class="toast show text-white" :class="toast.tipo === 'success' ? 'bg-success' : 'bg-danger'">
        <div class="d-flex">
          <div class="toast-body">{{ toast.msg }}</div>
          <button class="btn-close btn-close-white me-2 m-auto" @click="toast.show = false"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config.js';
import FelPreviewModal from '@/components/shared/FelPreviewModal.vue';

export default {
  name: 'ReportesRestaurante',
  components: { FelPreviewModal },
  data() {
    return {
      vista: 'resumen',
      // -- Resumen --
      tipoBusqueda: 'fecha',
      fecha:         new Date().toLocaleDateString('en-CA'),
      fechaInicio:   null,
      fechaFin:      null,
      horaInicio:    '06:30',
      horaFin:       '23:00',
      ordenar:       'metodo_asc',
      reporte:       null,
      cargandoResumen: false,
      // -- Detallado --
      dFechaInicio:  new Date().toLocaleDateString('en-CA'),
      dFechaFin:     new Date().toLocaleDateString('en-CA'),
      dHoraInicio:   '08:00',
      dHoraFin:      '07:59',
      dFiltroEstado: 'todos',
      reporteDetalle: null,
      cargandoDetalle: false,
      // -- Modal editar --
      modalEditarRest:  false,
      guardandoRest:    false,
      pagoEditarRest:   {},
      // -- Gastos generales / FEL --
      guardandoGastos: null,
      felUuidPreview:  null,
      // -- Toast --
      toast: { show: false, msg: '', tipo: 'success' },
    };
  },
  computed: {
    esContador() {
      return this.$store.getters.getUser?.IdRol === 11;
    },
    esAdminOContador() {
      return [1, 11].includes(this.$store.getters.getUser?.IdRol);
    },
    desgloseOrdenado() {
      const desglose = this.reporte?.desglose_por_metodo;
      if (!desglose) return [];
      const arr = Array.isArray(desglose)
        ? desglose.map((item) => ({ metodo: item.metodo, total: Number(item.total) }))
        : Object.entries(desglose).map(([metodo, total]) => ({ metodo, total: Number(total) }));
      switch (this.ordenar) {
        case 'total_desc': return arr.sort((a, b) => b.total - a.total);
        case 'total_asc':  return arr.sort((a, b) => a.total - b.total);
        default:           return arr.sort((a, b) => a.metodo.localeCompare(b.metodo));
      }
    },
  },
  methods: {
    numFmt(v) { return Number(v || 0).toFixed(2); },
    formatearFecha(f) {
      if (!f) return '';
      const [y, m, d] = f.split('-');
      return `${d}/${m}/${y}`;
    },
    mostrarToast(msg, tipo = 'success') {
      this.toast = { show: true, msg, tipo };
      setTimeout(() => (this.toast.show = false), 3500);
    },

    // ---------- RESUMEN ----------
    async obtenerReporte() {
      if (this.tipoBusqueda === 'rango' && (!this.fechaInicio || !this.fechaFin)) {
        this.mostrarToast('Seleccione ambas fechas', 'danger');
        return;
      }
      this.cargandoResumen = true;
      this.reporte = null;
      try {
        const params = this.tipoBusqueda === 'fecha'
          ? { fecha: this.fecha, hora_inicio: this.horaInicio, hora_fin: this.horaFin }
          : { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin };
        const res = await axios.get(`${API_URL}/reporte-restaurante-fecha`, { params });
        this.reporte = res.data;
      } catch {
        this.mostrarToast('Error al obtener el reporte', 'danger');
      } finally {
        this.cargandoResumen = false;
      }
    },
    async descargarPDF() {
      if (!this.reporte) return;
      try {
        const params = this.tipoBusqueda === 'fecha'
          ? { fecha: this.fecha, hora_inicio: this.horaInicio, hora_fin: this.horaFin, ordenar: this.ordenar }
          : { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin, ordenar: this.ordenar };
        const res = await axios.get(`${API_URL}/reporte-restaurante-fecha-pdf`, { params, responseType: 'blob' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        link.download = this.tipoBusqueda === 'fecha'
          ? `Ingresos_Restaurante_${this.fecha}.pdf`
          : `Ingresos_Restaurante_${this.fechaInicio}_${this.fechaFin}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch {
        this.mostrarToast('Error al generar el PDF', 'danger');
      }
    },
    async descargarExcel() {
      if (!this.reporte) return;
      try {
        const params = this.tipoBusqueda === 'fecha'
          ? { fecha: this.fecha, hora_inicio: this.horaInicio, hora_fin: this.horaFin, ordenar: this.ordenar }
          : { fecha_inicio: this.fechaInicio, fecha_fin: this.fechaFin, hora_inicio: this.horaInicio, hora_fin: this.horaFin, ordenar: this.ordenar };
        const res = await axios.get(`${API_URL}/reporte-restaurante-fecha-excel`, { params, responseType: 'blob' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        link.download = this.tipoBusqueda === 'fecha'
          ? `Ingresos_Restaurante_${this.fecha}.xlsx`
          : `Ingresos_Restaurante_${this.fechaInicio}_${this.fechaFin}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch {
        this.mostrarToast('Error al generar el Excel', 'danger');
      }
    },

    // ---------- DETALLADO ----------
    async buscarDetalle() {
      if (!this.dFechaInicio || !this.dFechaFin) return;
      this.cargandoDetalle = true;
      this.reporteDetalle  = null;
      try {
        const { data } = await axios.get(`${API_URL}/ingresos-restaurante-detalle`, {
          params: {
            fecha_inicio: this.dFechaInicio,
            fecha_fin:    this.dFechaFin,
            hora_inicio:  this.dHoraInicio,
            hora_fin:     this.dHoraFin,
            estado:       this.dFiltroEstado,
          },
        });
        // Inyectar filas de subtotal por día
        const rows = [];
        let lastDay = null;
        for (const fila of data.data) {
          const dia = fila.fecha_dia || fila.fecha_hora?.split(' ')[0];
          if (dia && dia !== lastDay) {
            if (lastDay && data.totales_por_dia?.[lastDay] !== undefined) {
              rows.push({ _subtotal_dia: lastDay, _subtotal_monto: data.totales_por_dia[lastDay] });
            }
            lastDay = dia;
          }
          rows.push(fila);
        }
        if (lastDay && data.totales_por_dia?.[lastDay] !== undefined) {
          rows.push({ _subtotal_dia: lastDay, _subtotal_monto: data.totales_por_dia[lastDay] });
        }
        this.reporteDetalle = { ...data, data: rows };
      } catch {
        this.mostrarToast('Error al obtener reporte detallado', 'danger');
      } finally {
        this.cargandoDetalle = false;
      }
    },
    async exportarDetalle(tipo) {
      const endpoint = tipo === 'pdf' ? 'ingresos-restaurante-detalle-pdf' : 'ingresos-restaurante-detalle-excel';
      const mime     = tipo === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const ext      = tipo === 'pdf' ? 'pdf' : 'xlsx';
      try {
        const res = await axios.get(`${API_URL}/${endpoint}`, {
          params: {
            fecha_inicio: this.dFechaInicio,
            fecha_fin:    this.dFechaFin,
            hora_inicio:  this.dHoraInicio,
            hora_fin:     this.dHoraFin,
            estado:       this.dFiltroEstado,
          },
          responseType: 'blob',
        });
        const link  = document.createElement('a');
        link.href   = URL.createObjectURL(new Blob([res.data], { type: mime }));
        link.download = `Ingresos_Restaurante_Detalle_${this.dFechaInicio}_${this.dFechaFin}.${ext}`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch {
        this.mostrarToast(`Error al generar ${tipo.toUpperCase()}`, 'danger');
      }
    },
    abrirEditarRest(fila) {
      this.pagoEditarRest = {
        id:               fila.id,
        monto:            fila.monto,
        numero_referencia: fila.numero_referencia === '—' ? '' : (fila.numero_referencia || ''),
        justificacion:    '',
      };
      this.modalEditarRest = true;
    },
    async guardarEdicionRest() {
      if (!this.pagoEditarRest.justificacion?.trim()) {
        this.mostrarToast('La justificación es obligatoria', 'danger');
        return;
      }
      this.guardandoRest = true;
      try {
        await axios.put(`${API_URL}/ingresos-restaurante/${this.pagoEditarRest.id}`, {
          Monto:            this.pagoEditarRest.monto,
          NumeroReferencia: this.pagoEditarRest.numero_referencia,
          justificacion:    this.pagoEditarRest.justificacion,
        });
        this.modalEditarRest = false;
        this.mostrarToast('Pago actualizado', 'success');
        await this.buscarDetalle();
      } catch (e) {
        this.mostrarToast(e.response?.data?.message || 'Error al actualizar', 'danger');
      } finally {
        this.guardandoRest = false;
      }
    },
    verFactura(uuid) {
      this.felUuidPreview = uuid;
    },
    async guardarGastosRest(fila, event) {
      const gastos = Number(event.target.value);
      this.guardandoGastos = fila.id;
      try {
        await axios.put(`${API_URL}/ingresos-restaurante/${fila.id}/gastos-generales`, {
          GastosGenerales: gastos,
        });
        this.mostrarToast('Gastos generales actualizados', 'success');
        await this.buscarDetalle();
      } catch (e) {
        event.target.value = fila.gastos_generales;
        this.mostrarToast(e.response?.data?.message || 'Error al actualizar gastos generales', 'danger');
      } finally {
        this.guardandoGastos = null;
      }
    },
  },
  async mounted() {
    await Promise.all([this.obtenerReporte(), this.buscarDetalle()]);
  },
};
</script>

<style scoped>
.resultado-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
}
.total-monto {
  font-size: 2.5rem;
  font-weight: 600;
  color: #198754;
}
</style>
